//USER

export const setData = (data) => {
    return {
        type: 'SET_USER_DATA',
        data
    }
};

export const patchData = (data) => {
    return {
        type: 'PATCH_USER_DATA',
        data
    }
};


export const setToken = (data) => {
    return {
        type: 'SET_AUTH_TOKEN',
        data
    }
};


export const setError = (data) => {
    return {
        type: 'SET_USER_ERROR',
        data
    }
};


export const setLoading = (data) => {
    return {
        type: 'SET_USER_LOADING',
        data
    }
};

export const updateTokenData = (data) => ({
    type: 'UPDATE_TOKEN_DATA',
    data
})
